/**
 * Action-Level Pricing Defaults
 *
 * These constants are the hardcoded fallback values for pricing and FX rates.
 * The authoritative source of truth is the admin settings row in DynamoDB
 * (see AdminSettingsEntity). These defaults are used:
 *   - As initial values before admin has configured anything
 *   - By the frontend for client-side cost pre-checks (where a DynamoDB
 *     round-trip isn't warranted — the real charge uses live values)
 *
 * Backend handlers should use AdminSettingsEntity.getSettings() instead
 * of importing these constants directly.
 *
 * See action-cost.ts for the full derivation from AWS service pricing.
 */

import { ADMIN_SETTINGS_DEFAULTS } from '../entities/admin-settings-entity';

// Re-export individual constants for backward compatibility with frontend
// code that imports them directly for client-side pre-checks.

/** Generated pipeline fixed cost (Bedrock description + image prompt + Nova Canvas). */
export const ARTICLE_FIXED_COST_CENTS = ADMIN_SETTINGS_DEFAULTS.articleFixedCostCents;

/** Imported pipeline fixed cost (cleanup + CEFR + summarise + description + image). */
export const IMPORT_FIXED_COST_CENTS = ADMIN_SETTINGS_DEFAULTS.importFixedCostCents;

/** Base per-word cost (Bedrock + Translate) in microcents, at 2x margin. */
export const ARTICLE_BASE_PER_WORD_MICROCENTS = ADMIN_SETTINGS_DEFAULTS.basePerWordMicrocents;

/** Audio per-word cost (Polly x2) in microcents, at 2x margin. */
export const ARTICLE_AUDIO_PER_WORD_MICROCENTS = ADMIN_SETTINGS_DEFAULTS.audioPerWordMicrocents;

/** Fixed cost per custom translation in cents. */
export const TRANSLATION_FIXED_COST_CENTS = ADMIN_SETTINGS_DEFAULTS.translationFixedCostCents;

/** Hardcoded FX rate: USD to GBP. */
export const USD_TO_GBP = ADMIN_SETTINGS_DEFAULTS.usdToGbp;

/** Hardcoded FX rate: USD to EUR. */
export const USD_TO_EUR = ADMIN_SETTINGS_DEFAULTS.usdToEur;
